import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer, updateArrayItemAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { createRecipe, deleteRecipe, editRecipe, getRecipe, getRecipeList } from './recipes.actions';
import { Recipe } from './recipes.types';

export type RecipeState = Recipe[];

const initialState: RecipeState = [];

const recipesReducer = createReducer(initialState, {
  [getRecipeList.done.type]: (state: RecipeState, action: Action<any>) => {
    return action.payload.result
      .filter((recipe) => !recipe.premix)
      .sort((elem1: Recipe, elem2: Recipe) => {
        return elem1.description.toLowerCase().localeCompare(elem2.description.toLowerCase());
      });
  },
  [getRecipe.done.type]: (state: RecipeState, action: Action<{ result: Recipe }>) => {
    const recipeDetail = action.payload.result;
    return state.map((recipe: Recipe) => {
      if (recipe.id === recipeDetail.id) {
        return {
          ...recipe,
          ...recipeDetail,
        };
      }
      return recipe;
    });
  },
  [createRecipe.done.type]: (state: RecipeState, action: Action<any>) => [...state, ...[action.payload.result]],
  [editRecipe.done.type]: (state: RecipeState, action: Action<any>) =>
    updateArrayItemAfterAsyncCall<Recipe>(state, action),
  [deleteRecipe.done.type]: (state: RecipeState, action: Action<any>) => {
    const deletedRationId: string = action.payload.result;
    const indexFound = state.findIndex((ration: Recipe) => ration.id === deletedRationId);
    return dotProp.delete(state, indexFound);
  },
});

export default recipesReducer;
